export const patientFormTexts = {
	options: {
		gender: [
			{
				value: "male",
				label: "Männlich",
			},
			{
				value: "female",
				label: "Weiblich",
			},
			{
				value: "diverse",
				label: "Divers",
			},
			{
				value: "no_answer",
				label: "Keine Angabe",
			},
		],
	},
};
